import React, { useEffect, useState } from 'react';
import { getStats } from '../api';

export default function DashboardPage() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getStats()
      .then(setStats)
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="loading">Loading dashboard...</div>;
  if (!stats) return <div className="empty-state"><p>Unable to load statistics.</p></div>;

  return (
    <div>
      <div className="page-header">
        <h1>Dashboard</h1>
        <p>Platform overview</p>
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-label">Total Users</div>
          <div className="stat-value">{stats.users.total}</div>
          <div className="stat-sub">{stats.users.active} active</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">New Today</div>
          <div className="stat-value">{stats.users.newToday}</div>
          <div className="stat-sub">registrations</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Community Posts</div>
          <div className="stat-value">{stats.posts.total}</div>
          <div className="stat-sub">active posts</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Emails</div>
          <div className="stat-value">{stats.emails.total}</div>
          <div className="stat-sub">{stats.emails.unread} unread</div>
        </div>
      </div>

      <div className="two-col-grid">
        {/* Recent registrations */}
        <div className="card">
          <div className="card-header">
            <span className="card-title">Recent Registrations (7 days)</span>
          </div>
          {stats.recentRegistrations.length === 0 ? (
            <p className="empty-hint">No recent registrations.</p>
          ) : (
            <table>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Count</th>
                </tr>
              </thead>
              <tbody>
                {stats.recentRegistrations.map((row) => (
                  <tr key={row.date}>
                    <td>{row.date}</td>
                    <td>{row.count}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        {/* Emails by category */}
        <div className="card">
          <div className="card-header">
            <span className="card-title">Emails by Category</span>
          </div>
          {stats.emails.byCategory.length === 0 ? (
            <p style={{ color: '#888', fontSize: 14 }}>No emails received yet.</p>
          ) : (
            <table>
              <thead>
                <tr>
                  <th>Category</th>
                  <th>Count</th>
                </tr>
              </thead>
              <tbody>
                {stats.emails.byCategory.map((row) => (
                  <tr key={row.category}>
                    <td>
                      <span className={`badge badge-${categoryColor(row.category)}`}>
                        {row.category}
                      </span>
                    </td>
                    <td>{row.count}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}

function categoryColor(cat) {
  switch (cat) {
    case 'support': return 'blue';
    case 'legal': return 'purple';
    case 'privacy': return 'yellow';
    default: return 'gray';
  }
}
